import { useEffect, useState } from 'react';
import { DEFAULT_SCREEN_WIDTH } from '../constants';

export const getDefaultMobileWidth = () => DEFAULT_SCREEN_WIDTH.mobileWidth;
export const getDefaultTabletWidth = () => DEFAULT_SCREEN_WIDTH.tabletWidth;

export const isScreenWidthMobile = () =>
  window.innerWidth <= getDefaultMobileWidth();

export const isScreenWidthTablet = () =>
  window.innerWidth <= getDefaultTabletWidth();

export const useScreenDetector = () => {
  const [isMobile, setIsMobile] = useState(isScreenWidthMobile());
  const [isTablet, setIsTablet] = useState(isScreenWidthTablet());

  const handleWindowSizeChange = () => {
    const shouldBeMobile = isScreenWidthMobile();
    if (shouldBeMobile !== isMobile) setIsMobile(shouldBeMobile);

    const shouldBeTablet = isScreenWidthTablet();
    if (shouldBeTablet !== isTablet) setIsTablet(shouldBeTablet);
  };

  useEffect(
    () => {
      window.addEventListener('resize', handleWindowSizeChange);

      return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
      };
    },
    [isMobile, isTablet],
  );

  return { isMobile, isTablet };
};
